import React from 'react';

import { Card, Typography } from '@mui/material';

import { useUserBioSummary } from '../hooks/useUserBioSummary';
import Spin from 'components/Spin';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';

type Props = {
  userId: string;
};

const SummaryCard: React.FC<Props> = ({ userId }) => {
  const theme = useThemeContext();
  const { bio, loading } = useUserBioSummary(userId);

  return (
    <Card sx={{ p: 2, width: '100%', height: '100%', background: theme.background.secondary }}>
      {/* <Typography variant="subtitle1" color="primary" fontWeight="bold" gutterBottom>
        Trajetória profissional
      </Typography> */}
      {loading ? (
        <Spin centerHorizontally centerVertically />
      ) : (
        <Typography variant="body2" color={bio ? 'text.primary' : 'text.secondary'}>
          {bio || 'Nenhum resumo preenchido.'}
        </Typography>
      )}
    </Card>
  );
};

export default SummaryCard;
